import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Autocomplete , { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
class ViewGroups extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            users: [],
            group_users: [],
            hr_permission: '',
            item_count: '',
            isLoadMore: 1,
            activePage: 1,
            loading: 1,
            fields: {},
            errors: {},
            group_name: '',
            group_type_name:'',
            trrop_details:[],
            group_id:'',
            editstate:'',
            group_info:'',
            get_group_type:[],
            group_type:'1',
            member_email: [],
            pod:[],
            group_sucsess:'',
            group_mail_msg:'',
            member_emailgroup:[],
            primary_email:[],
            listener_email:[],
            selected_pods:[]
        };

        this.onPrimaryemail = this.onPrimaryemail.bind(this);
        this.onListeneremail = this.onListeneremail.bind(this);
        this.onPODChange = this.onPODChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    back() {
        window.location.href = '/manageGroups/';
    }
    GetGroupType() {
        fetch(this.state.apiUrl + '/HrmanagementRest/getAddgroup/userAuthKey/' + this.state.userAuthKey , {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
               // console.log(findresponse.group_type)
                    this.setState({
                    get_group_type: findresponse.group_type,
                    member_email: findresponse.member_email,
                    member_emailgroup:findresponse.member_emailgroup,
                    pod: findresponse.pod,
                    })
                })
        }
    userList() {
        fetch(this.state.apiUrl + '/HrmanagementRest/viewGroupDetails/email/' + this.props.match.params.emailId +'/userId/' + this.state.userId+ '/userAuthKey/' + this.state.userAuthKey , {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    group_users: findresponse.group_users,
                    group_count: findresponse.group_count,
                    loading: 0,
                    group_name:findresponse.group_name,
                    group_type_name:findresponse.group_type_name,
                    hr_permission:findresponse.hr_permission,
                    description:findresponse.description,
                    trrop_details:findresponse.trrop_details,
                    group_id:findresponse.group_id,
                })
               
            })
    }
    showhelpdeskid(url, id) {
        if (id != '') {
            var win = window.open(url + id, '_blank');
            win.focus()
        }
    }
    goBack(){
		window.history.back();
    }
    handleValidation() {
        let fields = this.state.editstate?this.state.group_info:this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["name"] || fields["name"].trim() == "") {
            formIsValid = false;
            errors["groupname"] = "This field is required.";
        }
        if (!fields["email"] || fields["email"].trim() == "") {
            formIsValid = false;
            errors["groupemail"] = "This field is required.";
        }
        if (fields["email"] && !this.isValidEmailAddress(fields["email"])) {
            formIsValid = false;
            errors["groupemail"] = "Please Provide Correct Email.";
        }
        if (fields["email"]) {
            var str = fields["email"];
            var strvalue = str.toLowerCase();
            var res = strvalue.match('@muvi.com');
            if (!res) {
                formIsValid = false;
                errors["groupemail"] = "Please enter a valid domain name. The domain name should be muvi.com";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }
    isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }
    addGroup() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("addgroup").innerHTML = "Sending....";
        document.getElementById("addgroup").disabled = true;
        const fd = new FormData;
        fd.append('group_type', JSON.stringify(this.state.group_type));
        fd.append('name', JSON.stringify(this.state.name));
        fd.append('description', JSON.stringify(this.state.description));
        fd.append('email', JSON.stringify(this.state.email));
 		fd.append('primary_email', JSON.stringify(this.state.primary_email));
        fd.append('listener_email', JSON.stringify(this.state.listener_email));
        fd.append('selected_pods', JSON.stringify(this.state.selected_pods));
        let api_url = this.state.apiUrl + '/HrmanagementRest/AddGroup/userAuthKey/' + this.state.userAuthKey;
        if(this.state.editstate){
            api_url = this.state.apiUrl + '/HrmanagementRest/updateGroup/userAuthKey/' + this.state.userAuthKey+'/group_id/' + this.state.group_id;
            fd.append('group_inputs', JSON.stringify(this.state));
        }
        fetch(api_url, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                if (responseJson.code == 500) {
                    this.setState({ group_mail_msg: responseJson.msg,group_sucsess:'' })
                    document.getElementById("addgroup").innerHTML = "Sending";
                    document.getElementById("addgroup").disabled = false;
                }
                else if (responseJson.code == 200) {
                    this.setState({ group_sucsess: responseJson.msg,group_mail_msg:'' })
                    window.location.href = '/viewGroups/' + responseJson.chk_email;
                }
                })
    }
    onPrimaryemail = (selectedList) => {
		this.setState({
            primary_email: selectedList,
         }, function () {
		});
        
    }
    onListeneremail = (selectedList) => {
		this.setState({
			listener_email: selectedList
		});
    }
    onPODChange = (selectedList) => {
        this.setState({ selected_pods: selectedList });    
    }
    editGroupType(id,email){
        this.setState({ editstate: id,group_mail_msg:'' });
        fetch(this.state.apiUrl + '/HrmanagementRest/editGroup/userAuthKey/' + this.state.userAuthKey+'/id/' + id+'/email/' + email , {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                var list_member = findresponse.group_info['group_type'];
                if (findresponse.primary_email) {
                    var monitorList = [];
                    if (findresponse.primary_email) {
                        var monitorCount = 0;
                        var assigneList = list_member==5?this.state.member_emailgroup:this.state.member_email;
                        assigneList.forEach(element => {
                            findresponse.primary_email.forEach(element1 => {
                                if (element.email === element1) {
                                    monitorList[monitorCount++] = element;
                                }
                            });
                        });
                    }
                }
                if (findresponse.listener_email) {
                    var listenerList = [];
                    if (findresponse.listener_email) {
                        var listenerCount = 0;
                        var assigneList = this.state.member_email;
                        assigneList.forEach(element => {
                            findresponse.listener_email.forEach(element1 => {
                                if (element.email === element1) {
                                    listenerList[listenerCount++] = element;
                                }
                            });
                        });
                    }
                }
                if (findresponse.selected_pods) {
                    var podList = [];
                    if (findresponse.listener_email) {
                        var podCount = 0;
                        var assigneList = this.state.pod;
                        assigneList.forEach(element => {
                            findresponse.selected_pods.forEach(element1 => {
                                if (element.name === element1) {
                                    podList[podCount++] = element;
                                }
                            });
                        });
                    }
                }
                //console.log(findresponse.selected_pods);
            {/*if (findresponse.listener_email) {
                var assign_listner = findresponse.listener_email;
                var assignee_list = Object.values(this.state.member_email);
                var assigneeResult_list = assignee_list.find(item => item.email === assign_listner);
            }*/}
               this.setState({
                    group_info: findresponse.group_info,
                    primary_email:monitorList,
                    listener_email:listenerList,
                    selected_pods:podList,
            })
                this.groupChange('','',findresponse.group_info.group_type);
            })
    }
    groupChange(propertyName, event,type) {
        var group_type_name = document.getElementById('group_type_name').value;
        group_type_name=group_type_name?group_type_name:type;
        document.getElementById("podname").style.display = group_type_name == 3 ? 'block' : 'none';
        document.getElementById("membergroup").style.display = group_type_name == 3 || group_type_name == 5 ? 'none' : 'block';
        document.getElementById("emailgroup").style.display = group_type_name == 5 ? 'block' : 'none';
        if(this.state.editstate){
            const group_info = this.state.group_info;
            group_info[propertyName] = event.target.value;
            this.setState({ group_info: group_info });
        }else{
            let fields = this.state.fields;
            this.setState({ [event.target.name]: event.target.value });
            fields[event.target.name] = event.target.value;    
        }
    }
     getUserRows() {
        if (this.state.loading) {
            return (
                <div class="loader-new"></div>
            )
        } else {
            return (
                <div class="list_check">
           <div class="form-group row">
        <div class="col-xs-12">
                <div class="top-row hidden-xs er_top">
                <div class="left-section btn-muvi pull-left">
                {this.state.hr_permission=='yes'?<button type="button" className="btn btn-blue hidden-sm" onClick={() => this.editGroupType(this.state.group_id, this.props.match.params.emailId)} data-toggle="modal" data-target="#Modalgroups">Edit</button>:''}
                <button type="button" className="btn btn-black hidden-sm" onClick={() => this.back()} >Back</button>
                </div>
                </div>
                <div class="form-section no_border group_mem">
                <div class="details">
                <span>Description :&nbsp; &nbsp;&nbsp;</span>
                <span>{this.state.description?this.state.description:'--'}</span>
                </div>
                <div class="col-md-2" style={{ padding:0}}>
                <div class="details">
                    <span>Group Type :&nbsp; &nbsp;&nbsp;</span>
                    <span>{this.state.group_type_name!='1'?this.state.group_type_name:'--'}</span>
                </div>
                </div>
                <div class="col-md-4" style={{ padding:0}}>
                <div class="details">
                    <span>Group Email ID :&nbsp; &nbsp;&nbsp;</span>
                    <span>{this.props.match.params.emailId }</span>
                </div></div>
                <div class="col-md-3" style={{ padding:0}}>          
                <div class="details">
                    <span>{this.state.group_type_name=='Troop'?'Troop members':'Primary members'} :&nbsp; &nbsp;&nbsp;</span>
                    <span>{this.state.group_type_name=='Troop'?this.state.trrop_details.length:this.state.group_count}</span>
           </div>
           </div>
                </div>
            </div>
           </div>
                    <div> 
                    <h5 class="title"><span> {this.state.group_type_name=='Troop'?'Troop Members':'Group Members'}</span></h5>
                    {this.state.group_type_name=='Troop'?
                    <div class="tickets hidden-sm">
                        <ul class="tickets_head">
                            <li class="intra_col_30">Pod</li>
                            <li class="intra_col_30">Description</li>
                        </ul>
                        {
                            this.state.trrop_details.length == 0 ? <div className="text-center" style={{ color: '#888' }}>No Data Found</div>:
                            this.state.trrop_details.map((user, key) =>
                            <ul class="tickets_number">
                                <li class="intra_col_30">
                                    <div class="emps_details">
                                    <a href={`/viewGroups/${user.email}`}> <div class="emps_pic"><span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span></div>
                                    {user.name}</a>
                                    </div>
                                </li>
                                <li class="intra_col_30">
                                    <div>{user.description?user.description:'--'}</div>
                                </li>
                            </ul>
                        )
                           
                        }
                    </div>
                    
                    :<div class="tickets hidden-sm">
                    <ul class="tickets_head">
                            <li class="intra_col_30">Name</li>
                            <li class="intra_col_20">Designation</li>
                            <li class="intra_col_20">Department</li>
                            <li class="intra_col_20">Primary/Listener</li>
                        </ul>
                        {
                            this.state.group_users.length == 0 ? <div className="text-center" style={{ color: '#888' }}>No Data Found</div>:
                            this.state.group_users.map((user, key) =>
                                <ul class="tickets_number">
                                    <li class="intra_col_30">
                                        <div class="emps_details">
                                        {user.user_type==1? <a href={`/viewGroups/${user.email}`}> <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                        {user.name}</a>: <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>
                                            <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                            {user.name}
                                        </Link>}
                                        </div>
                                    </li>
                                    <li class="intra_col_20">
                                        <div>{user.position?user.position:'--'}</div>
                                    </li>
                                    <li class="intra_col_20">
                                        <div>{user.department?user.department:'--'}</div>
                                    </li>
                                    <li class="intra_col_20">
                                        <div>{user.type?user.type:'--'}</div>
                                    </li>
                                </ul>
                            )
                        }
                </div>}
                    
                    {
                        this.state.group_users.map((user, key) =>
                            <div class="customer_mob hidden-md">
                                <div class="custmer_list_mob emp_mob">
                                    {user.user_type==1? <a href={`/viewGroups/${user.email}`}> <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                    {user.name}</a>: <Link key={key} to={`/viewEmployee/${user.id}`} name={"max"}>
                                        <div class="emps_pic">{user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}</div>
                                        {user.name}
                                    </Link>}
                </div>
                            </div>)}
                </div>
                    {/* {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}*/}
                </div>
            )
        }
    }


    componentDidMount() {
        document.title = "Intranet | Groups";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.userList();
        this.GetGroupType();
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
        });
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
          });
        return (
            <div class="group">
                {/* <--modal end for change Type Name If Exists-!> */}
                <Header brecum_name="Groups" brecum_page="Groups" />
                <div class="right_col">
                       {/* <--modal start for reminder-!> */}
                       <div class="modal fade" id="Modalgroups" role="dialog">
                       <div class=" modal-dialog modal-md">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                   <h4 class="modal-title">Edit Group</h4>
                        </div>
                               
                       <div class="col-xs-12">
                               <div class="buttom_pod"></div>
                               <div class="col-xs-12">
                               <label for="staticEmail" class="col-sm-3 col-form-label">Type</label>
                               <div className="form-group col-sm-9">
                               <select class="form-control" id="group_type_name" name="group_type" value={this.state.group_info.group_type} onChange={this.groupChange.bind(this, 'group_type')}>
                               {/*<option value=''>Select Group Type</option>*/}
                                {
                                   this.state.get_group_type.map((dynamicData, key) =>
                                        <option value={dynamicData.key} >{dynamicData.value}</option>
                                    )
                                }
                            </select>
                          </div>
                            </div>
                            <div class="col-xs-12">
                               <label for="staticEmail" class="col-sm-3 col-form-label">Name</label>
                               <div className="form-group col-sm-9">
                               <input type="text" class="form-control" name="name" id="name" value={this.state.group_info.name} onChange={this.groupChange.bind(this, 'name')} />
                               <span class="error">{this.state.errors["groupname"]}</span>
                            </div>
                            </div>
                            <div class="col-xs-12">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Description</label>
                            <div className="form-group col-sm-9">
                            <textarea class="form-control" name="description" id="description" value={this.state.group_info.description} onChange={this.groupChange.bind(this, 'description')}></textarea>    
                         </div>
                         </div>
                         <div class="col-xs-12">
                         <div class="margin_top">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Email</label>
                            <div className="form-group col-sm-9">
                            <input type="text" class="form-control" name="email" id="email"  value={this.state.group_info.email} onChange={this.groupChange.bind(this, 'email')} />
                            <span class="error">{this.state.errors["groupemail"]}</span>
                         </div>
                         </div>
                         </div>
                         <div id="membergroup">
                         <div class="col-xs-12">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Primary Members</label>
                            <div className="form-group col-sm-9">
                        <div>
                            <Autocomplete
                                   multiple
                            id="tags-outlined"
                            className="autocomplete"
                            options={this.state.member_email}
                            getOptionLabel={(option) => option.name}
                            onChange={(event , value) => this.onPrimaryemail(value)}
                                   value={this.state.primary_email}
                            filterOptions={filterOptions} 
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    //label="Users Names"
                                    placeholder="Select"
                                />
                                )}
                        />
                         </div>
                         </div>
                         </div>

                         <div class="col-xs-12">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Listener Members</label>
                            <div className="form-group col-sm-9">
                            <div>
                            <Autocomplete
                                multiple
                            id="tags-outlined"
                            className="autocomplete"
                            options={this.state.member_email}
                            getOptionLabel={(option) => option.name}
                            onChange={(event , value) => this.onListeneremail(value)}
                                value={this.state.listener_email}
                            filterOptions={filterOptions} 
                            filterSelectedOptions
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                //label="Users Names"
                                placeholder="Select"
                            />
                            )}
                        />
                         </div>
                         </div>
                         </div>
                         
                         </div>
                         <div class="col-xs-12" id="podname" >
                         <label for="staticEmail" class="col-sm-3 col-form-label">Includes</label>
                         <div className="form-group col-sm-9">
                         <div>
                         <Autocomplete
                       multiple
                         id="tags-outlined"
                         className="autocomplete"
                         options={this.state.pod}
                         getOptionLabel={(option) => option.name}
                         onChange={(event , value) => this.onPODChange(value)}
                       value={this.state.selected_pods}
                         filterOptions={filterOptions} 
                         filterSelectedOptions
                         renderInput={(params) => (
                         <TextField
                             {...params}
                             variant="outlined"
                             //label="Users Names"
                             placeholder="Select"
                         />
                         )}
                     />
                      </div>
                      </div>
                   </div>
                   </div>
                   <div id="emailgroup">
                   <div class="col-xs-12">
                   <label for="staticEmail" class="col-sm-3 col-form-label">Members</label>
                   <div className="form-group col-sm-9">
                   <div>
                   <Autocomplete
                          multiple
                   id="tags-outlined"
                   className="autocomplete"
                   options={this.state.member_emailgroup}
                   getOptionLabel={(option) => option.name}
                   onChange={(event , value) => this.onPrimaryemail(value)}
                          value={this.state.primary_email}
                   filterOptions={filterOptions} 
                   filterSelectedOptions
                   renderInput={(params) => (
                       <TextField
                           {...params}
                           variant="outlined"
                           //label="Users Names"
                           placeholder="Select"
                       />
                       )}
               />
                </div>
                </div>
                   </div>        
                   </div>        
                   <span class="faid_message">{this.state.group_mail_msg}</span>
                   <span class="success_message">{this.state.group_sucsess}</span>
                        <div class="modal-footer">

                                   <button type="button" class="btn btn-sky" id="addgroup" onClick={() => this.addGroup()}>Save</button>
                                   <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                        </div>

                    </div>

                </div>
            </div>
                   {/* <--modal start-!> */}
                       <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span> {this.state.group_name}</span>
                        </div>
                         {this.getUserRows()}
                    </div>
                </div>

            </div>
        );
    }
}
export default ViewGroups;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/viewGroups.js